import { styled } from 'styled-components';
import { RadioSelectionCard } from '../../RadioSelectionCard';
export const StyledRadioSelectionCard = styled(RadioSelectionCard).withConfig({
  componentId: "aui__sc-auaqyd-0"
})(["padding-bottom:2rem;padding-left:0;padding-right:0;padding-top:0.75rem;line-height:1;"]);
export const TagContainer = styled.div.withConfig({
  componentId: "aui__sc-auaqyd-1"
})(["height:1.25rem;padding-bottom:0.5rem;"]);
export const DateContainer = styled.div.withConfig({
  componentId: "aui__sc-auaqyd-2"
})(["display:flex;flex-direction:column;gap:0.25rem;align-items:center;"]);